import React from 'react';
import Headerr from '../components/layout/header';
import Navbar from '../components/layout/navbar';
import Errorsec from '../sections/error-sec';
import { useState } from 'react';
import { useEffect } from 'react';
import Preloader from '../components/common/preloader';

const Error = () => {
                      const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Preloader />


    return ( 
        <>
          <main className='home-background'>

                    <Headerr />
                        <Errorsec />
                    <Navbar />

            </main>
        </>
     );
}
 
export default Error;